export const weatherInfo = [
  {
    id: 432423423,
    city: "city 1",
    forecast_percent: 22,
    forecast_num: 45.7,
    forecast_unit: "M",
    city_data: [
      {
        name: "Sample Stack 1",
        id: 99837465721,
        future_quarter: {
          ai_forecast: [
            620050, 690060, 670130, 690110, 691250, 742033, 735500, 739123,
          ],
          final_forecast: [
            720623, 765754, 846564, 784411, 811124, 823751, 860004, 855455,
          ],
          previous_quarter: [
            820438, 890100, 870250, 890000, 891100, 942033, 935500, 939123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 88,
            quarter_data: [
              744038, 670100, 640250, 670000, 671100, 712033, 705500, 719123,
            ],
          },
          final_forecast: {
            percent: 80,
            quarter_data: [
              410623, 455754, 536564, 474411, 501124, 513751, 550004, 545455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
      {
        name: "Sample Stack 2",
        id: 99837465732,
        future_quarter: {
          ai_forecast: [
            520080, 590070, 570150, 590100, 591200, 642033, 635500, 639123,
          ],
          final_forecast: [
            620623, 665754, 746564, 684411, 711124, 723751, 760004, 755455,
          ],
          previous_quarter: [
            720438, 790100, 770250, 790000, 791100, 842033, 835500, 839123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 78,
            quarter_data: [
              620438, 590100, 570250, 590000, 591100, 642033, 635500, 639123,
            ],
          },
          final_forecast: {
            percent: 50,
            quarter_data: [
              310623, 355754, 436564, 374411, 401124, 413751, 450004, 445455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
      {
        name: "Sample Stack 3",
        id: 99837465733,
        future_quarter: {
          ai_forecast: [
            420020, 490040, 470050, 490100, 491200, 542033, 535500, 539123,
          ],
          final_forecast: [
            520623, 565754, 646564, 584411, 611124, 623751, 660004, 655455,
          ],
          previous_quarter: [
            620438, 690100, 670250, 690000, 691100, 742033, 735500, 739123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 75,
            quarter_data: [
              550438, 520100, 500250, 520000, 521100, 572033, 565500, 569123,
            ],
          },
          final_forecast: {
            percent: 45,
            quarter_data: [
              250623, 295754, 376564, 314411, 341124, 353751, 390004, 385455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
      {
        name: "Sample Stack 4",
        id: 99837465734,
        future_quarter: {
          ai_forecast: [
            320040, 390080, 370150, 390120, 391300, 442033, 435500, 439123,
          ],
          final_forecast: [
            420623, 465754, 546564, 484411, 511124, 523751, 560004, 555455,
          ],
          previous_quarter: [
            520438, 590100, 570250, 590000, 591100, 642033, 635500, 639123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 72,
            quarter_data: [
              480438, 450100, 430250, 450000, 451100, 502033, 495500, 499123,
            ],
          },
          final_forecast: {
            percent: 40,
            quarter_data: [
              190623, 235754, 316564, 254411, 281124, 293751, 330004, 325455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
      {
        name: "Sample Stack 5",
        id: 99837465735,
        future_quarter: {
          ai_forecast: [
            220060, 290050, 270130, 290110, 291250, 342033, 335500, 339123,
          ],
          final_forecast: [
            320623, 365754, 446564, 384411, 411124, 423751, 460004, 455455,
          ],
          previous_quarter: [
            420438, 490100, 470250, 490000, 491100, 542033, 535500, 539123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 70,
            quarter_data: [
              410438, 380100, 360250, 380000, 381100, 432033, 425500, 429123,
            ],
          },
          final_forecast: {
            percent: 35,
            quarter_data: [
              130623, 175754, 256564, 194411, 221124, 233751, 270004, 265455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
    ],
  },
  {
    id: 432423426,
    city: "city 2",
    forecast_percent: 26,
    forecast_num: 48.5,
    forecast_unit: "T",
    city_data: [
      {
        name: "Sample Stack 1",
        id: 99837465738,
        future_quarter: {
          ai_forecast: [
            120080, 190070, 170150, 190100, 191200, 142033, 135500, 139123,
          ],
          final_forecast: [
            220623, 265754, 346564, 284411, 311124, 323751, 360004, 355455,
          ],
          previous_quarter: [
            320438, 390100, 370250, 390000, 391100, 442033, 435500, 439123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 80,
            quarter_data: [
              820438, 790100, 770250, 790000, 791100, 842033, 835500, 839123,
            ],
          },
          final_forecast: {
            percent: 70,
            quarter_data: [
              520623, 565754, 646564, 584411, 611124, 623751, 660004, 655455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
      {
        name: "Sample Stack 2",
        id: 99837465739,
        future_quarter: {
          ai_forecast: [
            520080, 490070, 470150, 490100, 491200, 542033, 535500, 539123,
          ],
          final_forecast: [
            420623, 465754, 546564, 484411, 511124, 523751, 560004, 555455,
          ],
          previous_quarter: [
            620438, 690100, 670250, 690000, 691100, 742033, 735500, 739123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 75,
            quarter_data: [
              720438, 690100, 670250, 690000, 691100, 742033, 735500, 739123,
            ],
          },
          final_forecast: {
            percent: 65,
            quarter_data: [
              420623, 465754, 546564, 484411, 511124, 523751, 560004, 555455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
    ],
  },
  {
    id: 432423427,
    city: "city 3",
    forecast_percent: 24,
    forecast_num: 47.3,
    forecast_unit: "M",
    city_data: [
      {
        name: "Sample Stack 10",
        id: 99837465740,
        future_quarter: {
          ai_forecast: [
            420060, 390050, 370130, 390110, 391250, 442033, 435500, 439123,
          ],
          final_forecast: [
            320623, 365754, 446564, 384411, 411124, 423751, 460004, 455455,
          ],
          previous_quarter: [
            420438, 490100, 470250, 490000, 491100, 542033, 535500, 539123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 85,
            quarter_data: [
              920438, 890100, 870250, 890000, 891100, 942033, 935500, 939123,
            ],
          },
          final_forecast: {
            percent: 75,
            quarter_data: [
              620623, 665754, 746564, 684411, 711124, 723751, 760004, 755455,
            ],
          },
          consumption: [
            920438, 890100, 870250, 890000, 891100, 942033, 935500, 939123,
          ],
        },
      },
      {
        name: "Sample Stack 11",
        id: 99837465741,
        future_quarter: {
          ai_forecast: [
            320040, 290080, 270150, 290120, 291300, 342033, 335500, 339123,
          ],
          final_forecast: [
            220623, 265754, 346564, 284411, 311124, 323751, 360004, 355455,
          ],
          previous_quarter: [
            320438, 390100, 370250, 390000, 391100, 442033, 435500, 439123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 90,
            quarter_data: [
              1020438, 990100, 970250, 990000, 991100, 1042033, 1035500,
              1039123,
            ],
          },
          final_forecast: {
            percent: 80,
            quarter_data: [
              820623, 865754, 946564, 884411, 911124, 923751, 960004, 955455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
    ],
  },
  {
    id: 432423428,
    city: "city 4",
    forecast_percent: 26,
    forecast_num: 49.8,
    forecast_unit: "M",
    city_data: [
      {
        name: "Sample Stack 1",
        id: 99837465742,
        future_quarter: {
          ai_forecast: [
            220050, 190060, 170130, 190110, 191250, 242033, 235500, 239123,
          ],
          final_forecast: [
            120623, 165754, 246564, 184411, 211124, 223751, 260004, 255455,
          ],
          previous_quarter: [
            220438, 290100, 270250, 290000, 291100, 342033, 335500, 339123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 85,
            quarter_data: [
              920438, 890100, 870250, 890000, 891100, 942033, 935500, 939123,
            ],
          },
          final_forecast: {
            percent: 75,
            quarter_data: [
              620623, 665754, 746564, 684411, 711124, 723751, 760004, 755455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
      {
        name: "Sample Stack 2",
        id: 99837465743,
        future_quarter: {
          ai_forecast: [
            420020, 390040, 370050, 390100, 391200, 442033, 435500, 439123,
          ],
          final_forecast: [
            320623, 365754, 446564, 384411, 411124, 423751, 460004, 455455,
          ],
          previous_quarter: [
            520438, 590100, 570250, 590000, 591100, 642033, 635500, 639123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 90,
            quarter_data: [
              1020438, 990100, 970250, 990000, 991100, 1042033, 1035500,
              1039123,
            ],
          },
          final_forecast: {
            percent: 80,
            quarter_data: [
              820623, 865754, 946564, 884411, 911124, 923751, 960004, 955455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
      {
        name: "Sample Stack 3",
        id: 99837465744,
        future_quarter: {
          ai_forecast: [
            620030, 590070, 570250, 590200, 591300, 642033, 635500, 639123,
          ],
          final_forecast: [
            520623, 565754, 646564, 584411, 611124, 623751, 660004, 655455,
          ],
          previous_quarter: [
            720438, 790100, 770250, 790000, 791100, 842033, 835500, 839123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 88,
            quarter_data: [
              744038, 670100, 640250, 670000, 671100, 712033, 705500, 719123,
            ],
          },
          final_forecast: {
            percent: 80,
            quarter_data: [
              410623, 455754, 536564, 474411, 501124, 513751, 550004, 545455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
    ],
  },
  {
    id: 432423429,
    city: "city 5",
    forecast_percent: 27,
    forecast_num: 51.6,
    forecast_unit: "T",
    city_data: [
      {
        name: "Sample Stack 15",
        id: 99837465745,
        future_quarter: {
          ai_forecast: [
            920050, 890060, 870150, 890100, 891200, 942033, 935500, 939123,
          ],
          final_forecast: [
            820623, 865754, 946564, 884411, 911124, 923751, 960004, 955455,
          ],
          previous_quarter: [
            1020438, 990100, 970250, 990000, 991100, 1042033, 1035500, 1039123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 85,
            quarter_data: [
              920438, 890100, 870250, 890000, 891100, 942033, 935500, 939123,
            ],
          },
          final_forecast: {
            percent: 75,
            quarter_data: [
              620623, 665754, 746564, 684411, 711124, 723751, 760004, 755455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
      {
        name: "Sample Stack 16",
        id: 99837465746,
        future_quarter: {
          ai_forecast: [
            820070, 790080, 770350, 790300, 791400, 842033, 835500, 839123,
          ],
          final_forecast: [
            720623, 765754, 846564, 784411, 811124, 823751, 860004, 855455,
          ],
          previous_quarter: [
            920438, 990100, 970250, 990000, 991100, 942033, 935500, 939123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 90,
            quarter_data: [
              1020438, 990100, 970250, 990000, 991100, 1042033, 1035500,
              1039123,
            ],
          },
          final_forecast: {
            percent: 80,
            quarter_data: [
              820623, 865754, 946564, 884411, 911124, 923751, 960004, 955455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
      {
        name: "Sample Stack 17",
        id: 99837465747,
        future_quarter: {
          ai_forecast: [
            720040, 690180, 670550, 690200, 691700, 742033, 735500, 739123,
          ],
          final_forecast: [
            620623, 665754, 746564, 684411, 711124, 723751, 760004, 755455,
          ],
          previous_quarter: [
            920438, 890100, 870250, 890000, 891100, 942033, 935500, 939123,
          ],
        },
        past_quarter: {
          ai_forecast: {
            percent: 88,
            quarter_data: [
              744038, 670100, 640250, 670000, 671100, 712033, 705500, 719123,
            ],
          },
          final_forecast: {
            percent: 80,
            quarter_data: [
              410623, 455754, 536564, 474411, 501124, 513751, 550004, 545455,
            ],
          },
          consumption: [
            744008, 620100, 640250, 620000, 651100, 752033, 735500, 769123,
          ],
        },
      },
    ],
  },
];

export const quarters = [
  "Q2 2022",
  "Q3 2022",
  "Q4 2022",
  "Q1 2023",
  "Q2 2023",
  "Q3 2023",
  "Q4 2023",
  "Q1 2024",
  "Q2 2024",
];

export const futureQuarters = [
  "Q3 2024",
  "Q4 2024",
  "Q1 2025",
  "Q2 2025",
  "Q3 2025",
  "Q4 2025",
  "Q1 2026",
  "Q2 2026",
];
